import React, { useState } from 'react'
import Sidebar from '../components/CommonSections/SideBar';
import Navbar from '../components/CommonSections/Navbar';
import Footer from '../components/CommonSections/Footer';
import InfoSection from '../components/AboutPage/InfoSection';
import { aboutObjOne, aboutObjTwo, aboutObjThree, aboutObjFour } from '../components/AboutPage/InfoSection/Data';
import ScrollToTop from '../components/ScrollToTop';

const AboutMePage = () => {

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }
    return (
        <>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />
            <InfoSection {...aboutObjOne} />
            <InfoSection {...aboutObjTwo} />
            <InfoSection {...aboutObjThree} />
            <InfoSection {...aboutObjFour} />
            <Footer />
        </>
    )
}

export default AboutMePage
